// window.THEME_MAP_MARKER = window.THEME_OPTIONS.theme_url + '/public/svg/map_marker.svg';
window.THEME_MAP_MARKER = function(size) {
  let color = getComputedStyle(document.querySelector('body')).getPropertyValue('--color-primary-light');
  let stroke = '#f9f5ed'; // getComputedStyle(document.querySelector('body')).getPropertyValue('--color-primary-light');

  return {
    // size: new google.maps.Size(30, 42),
    // scaledSize: new google.maps.Size(30, 42),
    // origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(15, 42),
    scale: (size == 'large') ? 1.5 : 1,
    path: "M15.0020099,0 C6.72108591,0.0088600894 0.0099696122,6.71907725 0,15 C0,25.2646389 13.4242262,40.3349859 13.9950422,40.9721292 C14.2512188,41.2574158 14.6165748,41.4203784 15,41.4203784 C15.3834252,41.4203784 15.7487812,41.2574158 16.0049578,40.9721292 C16.5757738,40.3349859 30,25.2666488 30,15 C29.9900349,6.72064442 23.2813641,0.011074519 15.0020099,0 L15.0020099,0 Z M15.0020099,22.5492429 C10.8337882,22.5492429 7.4547769,19.1702316 7.4547769,15.0020099 C7.4547769,10.8337882 10.8337882,7.4547769 15.0020099,7.4547769 C19.1702316,7.4547769 22.5492429,10.8337882 22.5492429,15.0020099 C22.5448118,19.1683948 19.1683948,22.5448118 15.0020099,22.5492429 Z",
    fillColor: color,
    fillOpacity: 1.0,
    strokeColor: stroke,
    strokeOpacity: 1.0,
    strokeWeight: 1,
  };
};

// https://snazzymaps.com/style/1243/xxxxxxxxxxx
window.THEME_MAP_STYLES = [
  {
    "featureType": "all",
    "elementType": "labels.text",
    "stylers": [
      {
        "color": "#878787"
      }
    ]
  },
  {
    "featureType": "all",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [
      {
        "color": "#f9f5ed"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "all",
    "stylers": [
      {
        "color": "#aee0f4"
      }
    ]
  }
];

// window.THEME_MAP_STYLES = [
//   {
//     "featureType": "administrative",
//     "elementType": "labels.text.fill",
//     "stylers": [
//       {
//         "color": "#444444"
//       }
//     ]
//   },
//   {
//     "featureType": "landscape",
//     "elementType": "all",
//     "stylers": [
//       {
//         "color": "#f2f2f2"
//       }
//     ]
//   },
//   {
//     "featureType": "poi",
//     "elementType": "all",
//     "stylers": [
//       {
//         "visibility": "off"
//       }
//     ]
//   },
//   {
//     "featureType": "road",
//     "elementType": "all",
//     "stylers": [
//       {
//         "saturation": -100
//       },
//       {
//         "lightness": 45
//       }
//     ]
//   },
//   {
//     "featureType": "road.highway",
//     "elementType": "all",
//     "stylers": [
//       {
//         "visibility": "simplified"
//       }
//     ]
//   },
//   {
//     "featureType": "road.arterial",
//     "elementType": "labels.icon",
//     "stylers": [
//       {
//         "visibility": "off"
//       }
//     ]
//   },
//   {
//     "featureType": "transit",
//     "elementType": "all",
//     "stylers": [
//       {
//         "visibility": "off"
//       }
//     ]
//   },
//   {
//     "featureType": "water",
//     "elementType": "all",
//     "stylers": [
//       {
//         "color": "#636363"
//       },
//       {
//         "visibility": "on"
//       }
//     ]
//   }
// ];